/**
 * @file 项目相关api
 */
import { get, post } from '@web3/base-utils';
import {
  GetProjectDetailParams,
  GetProjectDetailRes,
  GetUserRankAddressParams,
  GetUserRankAddressRes,
  PostCompleteTaskParams,
  PostCompleteTaskRes,
  GetPointsParams,
  GetPointsRes,
  PostVoteParams,
  PostVoteRes,
  postLotteryParams,
  postLotteryRes,
} from '@/types/project';

/**
 * 项目详情
 */
export const getProjectDetail = (params: GetProjectDetailParams) => {
  return get<GetProjectDetailRes>(
    `/spot/api/web3/content/wsot/projectDetail`,
    params
  );
};

/**
 * 积分贡献排行榜
 */
export const getUserRankAddress = (params: GetUserRankAddressParams) => {
  return get<GetUserRankAddressRes>(
    `/spot/api/web3/content/wsot/userRankAddress`,
    params
  );
};

/**
 * 完成任务
 */
export const postCompleteTask = (params: PostCompleteTaskParams) => {
  return post<PostCompleteTaskRes>(
    `/spot/api/web3/content/wsot/completeTaskV2`,
    params
  );
};

export const getPoints = (params: GetPointsParams) => {
  return post<GetPointsRes>(`/spot/api/web3/content/wsot/getPoint`, params);
};

/**
 * 抽奖
 */
export const postVote = (params: PostVoteParams) => {
  return post<PostVoteRes>(`/spot/api/web3/content/wsot/vote`, params);
};

/**
 * 抽奖
 */
export const postLottery = (params: postLotteryParams) => {
  return post<postLotteryRes>(`/spot/api/web3/content/wsot/lotteryV2`, params);
};
